<!-- TIME -->
<div class="end-card-left" *ngIf="!assistancecase.services[0].arrivalStartTime && !assistancecase.services[0].programedTicketStartTime && assistancecase.status == 1">
    <app-progressbar-timer [starttime]="assistancecase.date_start"
        [case_id]="assistancecase.id"
        (timerflag)="setColorValue($event)"
        [maxSeconds]="(+assistancecase.services[0].expected_time * 60)"
        [redSeconds]="(+assistancecase.services[0].expected_time * 60)">
    </app-progressbar-timer>
</div>
<div class="end-card-left" *ngIf="!assistancecase.services[0].arrivalStartTime && assistancecase.services[0].programedTicketStartTime && assistancecase.status == 1">
    <app-progressbar-timer [starttime]="assistancecase.services[0].programedTicketStartTime"
        [case_id]="assistancecase.id"
        (timerflag)="setColorValue($event)"
        [maxSeconds]="(+assistancecase.services[0].expected_time * 60)"
        [redSeconds]="(+assistancecase.services[0].expected_time * 60)">
    </app-progressbar-timer>
</div>

    <!-- Time to notify to customer (Programmed and not programmed) -->
<div class="end-card-left" *ngIf="assistancecase.services[0].arrivalStartTime && !assistancecase.services[0].programedTicketStartTime">
    <!-- 
        Ocurre en dado caso no es una asistencia programada y si ya se asigno provider 
    -->
    <app-progressbar-timer *ngIf="!assistancecase.services[0].notifyToCustomerEndTime && assistancecase.status == 1"
        [case_id]="assistancecase.id"
        (timerflag)="setColorValue($event)"
        [starttime]="assistancecase.services[0].arrivalStartTime"
        [maxSeconds]="(+assistancecase.services[0].expected_time_customer * 60)" [yellowSeconds]="1"
        [redSeconds]="(+assistancecase.services[0].expected_time_customer * 60)">
    </app-progressbar-timer>
    <app-progressbar-timer *ngIf="!assistancecase.services[0].notifyToCustomerEndTime && assistancecase.status == 2"
        [case_id]="assistancecase.id"
        (timerflag)="setColorValue($event)"
        [starttime]="assistancecase.services[0].arrivalStartTime"
        [endtime]="assistancecase.date_end" [setColorBlue]="true"
        [maxSeconds]="(+assistancecase.services[0].expected_time_customer * 60)" [yellowSeconds]="1"
        [redSeconds]="(+assistancecase.services[0].expected_time_customer * 60)">
    </app-progressbar-timer>
    <app-progressbar-timer *ngIf="assistancecase.services[0].notifyToCustomerEndTime"
        [case_id]="assistancecase.id"
        (timerflag)="setColorValue($event)"
        [starttime]="assistancecase.services[0].arrivalStartTime"
        [endtime]="assistancecase.services[0].notifyToCustomerEndTime" [setColorBlue]="true"
        [maxSeconds]="(+assistancecase.services[0].expected_time_customer * 60)" [yellowSeconds]="1"
        [redSeconds]="(+assistancecase.services[0].expected_time_customer * 60)">
    </app-progressbar-timer>
</div>
<div class="end-card-left" *ngIf="assistancecase.services[0].arrivalStartTime && assistancecase.services[0].programedTicketStartTime">
    <!-- 
        Ocurren si son asistencias programadas y si ya se asignó provider

        Si no tiene endtime notify to customer:
        - Iniciar el timer en fecha de asignacion de proveedor (arrival) si la asignacion de proveedor 
        se realizó después (es mayor) que la fecha de programación.
        - Caso contrario se iniciará en la fecha de programación porque no es posible asignar
        proveedor antes de llegar el tiempo de gestión.
    -->
    <app-progressbar-timer *ngIf="!assistancecase.services[0].notifyToCustomerEndTime && assistancecase.services[0].programedTicketStartTime < assistancecase.services[0].arrivalStartTime"
        [case_id]="assistancecase.id"
        (timerflag)="setColorValue($event)"
        [starttime]="assistancecase.services[0].arrivalStartTime"
        [maxSeconds]="(+assistancecase.services[0].expected_time_customer * 60)" [yellowSeconds]="1"
        [redSeconds]="(+assistancecase.services[0].expected_time_customer * 60)">
    </app-progressbar-timer>
    <app-progressbar-timer *ngIf="!assistancecase.services[0].notifyToCustomerEndTime && assistancecase.services[0].programedTicketStartTime > assistancecase.services[0].arrivalStartTime"
        [case_id]="assistancecase.id"
        (timerflag)="setColorValue($event)"
        [starttime]="assistancecase.services[0].programedTicketStartTime"
        [maxSeconds]="(+assistancecase.services[0].expected_time_customer * 60)" [yellowSeconds]="1"
        [redSeconds]="(+assistancecase.services[0].expected_time_customer * 60)">
    </app-progressbar-timer>

    <!-- 
        Si tiene endtime notify to customer
        - el mismo caso de uso del anterior con la excepción que tendrá el endtime correspondiente
    -->
    <app-progressbar-timer *ngIf="assistancecase.services[0].notifyToCustomerEndTime && assistancecase.services[0].programedTicketStartTime < assistancecase.services[0].arrivalStartTime"
        [case_id]="assistancecase.id"
        (timerflag)="setColorValue($event)"
        [starttime]="assistancecase.services[0].arrivalStartTime"
        [endtime]="assistancecase.services[0].notifyToCustomerEndTime" [setColorBlue]="true"
        [maxSeconds]="(+assistancecase.services[0].expected_time_customer * 60)" [yellowSeconds]="1"
        [redSeconds]="(+assistancecase.services[0].expected_time_customer * 60)">
    </app-progressbar-timer>
    <app-progressbar-timer *ngIf="assistancecase.services[0].notifyToCustomerEndTime && assistancecase.services[0].programedTicketStartTime > assistancecase.services[0].arrivalStartTime"
        [case_id]="assistancecase.id"
        (timerflag)="setColorValue($event)"
        [starttime]="assistancecase.services[0].programedTicketStartTime"
        [endtime]="assistancecase.services[0].notifyToCustomerEndTime" [setColorBlue]="true"
        [maxSeconds]="(+assistancecase.services[0].expected_time_customer * 60)" [yellowSeconds]="1"
        [redSeconds]="(+assistancecase.services[0].expected_time_customer * 60)">
    </app-progressbar-timer>
</div>